export const VenueData = {
    list: [{
        id: 1,
        name: '1st Floor Conference room',
        desc: '',
        seats: "64",
        accessible: true,
        fullDayRate: 10000,
        hourlyRate: 1000,
        image: 'https://www.dubaichambers.com/documents/20119/986442/1conference_1.jpg',
        capacity: 200,
        size: 504,
        amenities: 'Whiteboard, Wi-Fi, TV Screen',
        memberRate: 2000,
        nonMemberRate: 3000,
        sliderImages: [{
            url: "https://www.dubaichambers.com/documents/20119/986442/1conference_1.jpg"
        }, {
            url: "https://www.dubaichambers.com/documents/20119/986442/1conference_2.jpg"
        }, {
            url: "https://www.dubaichambers.com/documents/20119/986442/1conference_3+%281%29.jpg"
        }, {
            url: "https://www.dubaichambers.com/documents/20119/986442/1conference_4+%281%29.jpg"
        }],
        days: [{
            date: "2025-12-23",
            slots: [
                { label: '09:00-10:00' },
                { label: '10:00-11:00', booked: true },
                { label: '11:00-12:00', booked: false },
                { label: '12:00-13:00' },
                { label: '13:00-14:00', booked: false },
                { label: '14:00-15:00' },
                { label: '15:00-16:00' }
            ]
        }, {
            date: "2025-12-24",
            slots: [
                { label: '09:00-10:00' },
                { label: '10:00-11:00' },
                { label: '11:00-12:00' },
                { label: '12:00-13:00' },
                { label: '13:00-14:00' },
                { label: '14:00-15:00' },
                { label: '15:00-16:00' }
            ]
        }]
    },
    {
        id: 2,
        name: '2nd Floor Delegation Room',
        desc: '',
        seats: "700",
        accessible: true,
        fullDayRate: 10000,
        hourlyRate: 1000,
        image: 'https://www.dubaichambers.com/documents/20119/986442/2ndfloor_1+%281%29.jpg',
        capacity: 200,
        size: 504,
        amenities: 'Whiteboard, Wi-Fi, TV Screen',
        memberRate: 2000,
        nonMemberRate: 3000,
        sliderImages: [{
            url: "https://www.dubaichambers.com/documents/20119/986442/2ndfloor_1+%281%29.jpg"
        }, {
            url: "https://www.dubaichambers.com/documents/20119/986442/2ndfloor_2+%281%29.jpg",
        }, {
            url: "https://www.dubaichambers.com/documents/20119/986442/2ndfloor_3+%281%29.jpg",
        }, {
            url: "https://www.dubaichambers.com/documents/20119/986442/2ndfloor_4.jpg",
        }],

        days: [{
            date: "2025-12-24",
            slots: [
                { label: '09:00-10:00' },
                { label: '10:00-11:00' },
                { label: '11:00-12:00' },
                { label: '12:00-13:00' },
                { label: '13:00-14:00' },
                { label: '14:00-15:00' },
                { label: '15:00-16:00' }
            ]
        }]
    }]
}